import type { SVGProps } from "react";

export const PlusSquaredIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      {...props}
      className="fill-current"
    >
      <path
        d="M8 4C8.44183 4 8.8 4.35817 8.8 4.8V7.2H11.2C11.6418 7.2 12 7.55817 12 8C12 8.44183 11.6418 8.8 11.2 8.8H8.8V11.2C8.8 11.6418 8.44183 12 8 12C7.55817 12 7.2 11.6418 7.2 11.2V8.8H4.8C4.35817 8.8 4 8.44183 4 8C4 7.55817 4.35817 7.2 4.8 7.2H7.2V4.8C7.2 4.35817 7.55817 4 8 4Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.6 0C14.9255 0 16 1.07452 16 2.4V13.6C16 14.9255 14.9255 16 13.6 16H2.4C1.07452 16 0 14.9255 0 13.6V2.4C0 1.07452 1.07452 0 2.4 0H13.6ZM2.4 1.6C1.95817 1.6 1.6 1.95817 1.6 2.4V13.6C1.6 14.0418 1.95817 14.4 2.4 14.4H13.6C14.0418 14.4 14.4 14.0418 14.4 13.6V2.4C14.4 1.95817 14.0418 1.6 13.6 1.6H2.4Z"
        fill="currentColor"
      />
    </svg>
  );
};
